import { cn } from "@/lib/utils";

export const SectionLabel = ({ index, title, dark = true, className }) => (
  <p
    className={cn(
      "font-subheading text-xs font-semibold uppercase tracking-[0.3em]",
      dark ? "text-brand-purple" : "text-brand-purple",
      className
    )}
  >
    — {index ? `${index} / ` : ""}
    {title} —
  </p>
);
